import { render, staticRenderFns } from "./modalSolicitarNovaAmostra.vue?vue&type=template&id=4e2fc564&"
import script from "./modalSolicitarNovaAmostra.vue?vue&type=script&lang=js&"
export * from "./modalSolicitarNovaAmostra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports